import { formBundleSignatureRequestApi, formDeliveryRequestApi } from 'app/services/api';

import { FeatureFlag } from 'constants/featureFlags';
import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { getFormattedFormDeliveryRequestsData } from 'utils/forms';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const LOAN_BUNDLE_HISTORY_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/loanBundleHistory`,
  {
    GET_HISTORY: 'GET_HISTORY',
    GET_HISTORY_REJECTED_STATUS: 'GET_HISTORY_REJECTED_STATUS',
  },
);

export const getLoanBundleHistoryAction = params =>
  catchAsyncActionError(params => async dispatch => {
    const { data } = await formDeliveryRequestApi.getFormDeliveryRequests(params);

    return dispatch({
      type: LOAN_BUNDLE_HISTORY_ACTION_TYPE.GET_HISTORY,
      payload: getFormattedFormDeliveryRequestsData(data),
    });
  })({
    ...params,
    rejectedAction: () => ({
      type: LOAN_BUNDLE_HISTORY_ACTION_TYPE.GET_HISTORY_REJECTED_STATUS,
    }),
  });

export const reissueRecipientSigningLinkAction = catchAsyncActionError(params => async () => {
  const { data } = await formDeliveryRequestApi.reissueRecipientSigningLink(params);

  return data;
});

export const correctRecipientEmailAction = catchAsyncActionError(params => async () => {
  const { data } = await formDeliveryRequestApi.correctRecipientEmail(params);

  return data;
});

export const switchRecipientAuthorizationAction = catchAsyncActionError(params => async () => {
  const { data } = await formDeliveryRequestApi.switchRecipientAuthorization(params);

  return data;
});

export const recordRecipientMailedDeliveryAction = catchAsyncActionError(params => async () => {
  const { data } = await formDeliveryRequestApi.recordRecipientMailedDelivery(params);

  return data;
});

export const correctGeneratedOutsideFormDeliveryDatesAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const isFormsConsolidationEnabled = selectFeatureFlagByKey(
      FeatureFlag.FormsConsolidationEnabled,
    )(getState());

    const { data } = isFormsConsolidationEnabled
      ? await formDeliveryRequestApi.correctGeneratedOutsideDates(params)
      : await formBundleSignatureRequestApi.correctGeneratedOutsideFormDeliveryDates(params);

    return data;
  },
);
